<template>
  <layout-center>
    <v-card class="mx-auto">
      <list-with-avatar
        :items="items"
        @toggleActive="
          ({ clickedItem }) => {
            $store.dispatch('dashboard/prep/NotesToggleActive', {
              item: clickedItem,
            });
          }
        "
        @update="
          ({ clickedItem }) => {
            $router.push({
              name: 'dashboard-prep-notes-create',
              params: { id: clickedItem.id },
            });
          }
        "
        @clicked="
          ({ clickedItem }) => {
            $router.push({
              name: 'dashboard-prep-notes-create',
              params: { id: clickedItem.id },
            });
          }
        "
      />
      <fab-button
        :icon="'mdi-plus'"
        color="primary"
        @clicked="$router.push({ name: 'dashboard-prep-notes-create' })"
      />
    </v-card>
  </layout-center>
</template>

<script>
import { mapGetters } from "vuex";
import FabButton from "@/components/FabButton.vue";
import ListWithAvatar from "../../modules/ListWithAvatar.vue";
import LayoutCenter from "@/layouts/LayoutCenter.vue";

export default {
  name: "dashboard-prep-notes",
  components: {
    FabButton,
    ListWithAvatar,
    LayoutCenter,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      auth: "auth/auth",
    }),
  },
  watch: {},
  methods: {},
  created() {
    this.$store.dispatch("dashboard/prep/NotesGetAll", { context: this });
  },
};
</script>
